import React from 'react';
import PropTypes from 'prop-types';

export default function IconPlus(props) {
  const {styles, className, id} = props;
  return (
    <svg 
      id={id}
      className={className}
      width={styles.width || '15px'} 
      height={styles.height || '15px'} 
      viewBox="0 0 32 32" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g 
          id="Icon/Action/Add" 
          fill={styles.fill || 'gray'}>
          <polygon id="plus" points="13.1764706 -8.42124724e-15 13.1764706 13.1764706 -1.68424945e-14 13.1764706 -1.68424945e-14 18.8235294 13.1764706 18.8235294 13.1764706 32 18.8235294 32 18.8235294 18.8235294 32 18.8235294 32 13.1764706 18.8235294 13.1764706 18.8235294 -8.42124724e-15"></polygon>
        </g>
      </g>
    </svg>
  );
}

IconPlus.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
  
IconPlus.defaultProps = {
  id: "",
  className: "",
  styles: {
    fill: "#677383",
    height: "14px",
    width: "14px"
  }
};
